import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { CASE_QUERY_KEYS } from 'app/modules/cases/queries/keys';
import { post } from 'app/shared/utils/fetchr';
import { InvestigationActionPayload } from 'app/modules/investigations/types/requests';
import { selectDLEnabledForCaseDetail } from 'app/shared/featureFlags/selectors';
import { CHECKLIST_QUERY_KEYS } from 'app/shared/customChecklist/queries/keys';

export const useRequeueCase = (ids: number[]) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const useNewEndpoint = useSelector(selectDLEnabledForCaseDetail);

  return useMutation({
    mutationFn: (queueID: number) =>
      post(
        useNewEndpoint
          ? '/v1/investigations/cached/action'
          : '/v1/investigations/action',
        {
          object_ids: ids,
          object_type: 'CASE',
          investigation_queue_id: queueID,
        } satisfies InvestigationActionPayload,
      ),
    onError: () =>
      dispatch(
        sendErrorToast('Failed to change case queue. Please try again.'),
      ),
    onSuccess: () => {
      dispatch(sendSuccessToast('Successfully changed case queue.'));
      ids.forEach((i) => {
        queryClient.invalidateQueries({
          queryKey: CASE_QUERY_KEYS.getCase(i, useNewEndpoint),
        });
        // checklist might change since its queue-based
        queryClient.invalidateQueries({
          queryKey: CHECKLIST_QUERY_KEYS.getChecklistSubmission(i),
        });
      });
    },
  });
};
